<template>
  <div id="content">
    <form>
      <div class="inner">
        <img
            class="logo_operator"
            :src="pathToLogo"
            :alt="'Logo' | translate" v-if="hasLogo">
        <h1 v-translate>Ke stažení</h1>
        <h1 class="h1_print">{{ operatorName }}</h1>
      </div>
      <div class="responsiveTabs">
        <ul class="tabs">
          <li :class="getActiveTabClass('documents')" v-if="this.showDocuments">
            <a
                                @click.prevent.stop="activateTab('documents')"
                v-translate>Dokumenty
            </a>
          </li>
          <li :class="getActiveTabClass('program-structure')">
            <a
                                @click.prevent.stop="activateTab('program-structure')"
                v-translate>Programová skladba
            </a>
          </li>
          <li :class="getActiveTabClass('thematic-packages')">
            <a
                                @click.prevent.stop="activateTab('thematic-packages')"
                v-translate>Tématické balíčky
            </a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('documents')" v-if="this.showDocuments">
          <documents
              v-for="(section, index) in publicDirs"
              :key="index"
              :items="section.files"
              :title="section.path"
              :dir="section.path"
          ></documents>
          <documents
              :items="publicFiles"
              :title="othersTitle"
          ></documents>
        </div>
        <div class="tabs_content" v-show="isActiveTab('program-structure')">
          <section v-if="this.changeOperatorAllowed" class="no_print">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <select-box
                    id="operatorList_program_structure"
                    v-model="idOperator"
                    :options="operatorOptions"
                >
                  <translate class="translate">Operátor</translate>
                </select-box>
              </div>
            </div>
          </section>
          <program-structure
              :channels="channels"
              :basic-channel-packages="basicChannelPackages"
              :idOperator="idOperator"
          ></program-structure>
        </div>
        <div class="tabs_content" v-show="isActiveTab('thematic-packages')">
          <section v-if="this.changeOperatorAllowed" class="no_print">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <select-box
                    id="operatorList_thematic_packages"
                    v-model="idOperator"
                    :options="operatorOptions"
                >
                  <translate class="translate">Operátor</translate>
                </select-box>
              </div>
            </div>
          </section>
          <thematic-packages
              :thematic-channel-packages="thematicChannelPackages"
          ></thematic-packages>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import selectOperatorBusinessModel from "@/components/mixins/select-operator-business-model"
import userSettings from "@/components/mixins/user-settings"
import tabs from "@/components/mixins/tabs"
import message from "@/components/mixins/message"
import Documents from "@/components/views/downloads/documents/Documents"
import ProgramStructure from "@/components/views/downloads/program-structure/ProgramStructure"
import ThematicPackages from "@/components/views/downloads/thematic-packages/ThematicPackages"

export default {
  name: "Downloads",
  components: {ThematicPackages, ProgramStructure, Documents},
  mixins: [userSettings, tabs, message, selectOperatorBusinessModel],
  created(DownloadService, OperatorService) {
    this.downloadService = DownloadService
    this.operatorService = OperatorService

    this.downloadService.isWebdavConfigured()
        .then((data) => {
          this.loadedWebdavInfo = true
          if (data['is_webdav_configured']) {
            this.getDownloads();
          } else {
            this.activateTab('program-structure')
          }
        })

    if (this.changeOperatorAllowed) {
      this.getOperators()
        .then(() => {
          this.idOperator = this.operators[Object.keys(this.operators)[0]]['id']
        })
    } else {
      this.getProgramStructureAndThematicPackages()
    }
  },
  data() {
    return {
      moduleName: 'downloads',
      activeTab: 'documents',
      publicDirs: [],
      publicFiles: [],
      channels: [],
      basicChannelPackages: {},
      thematicChannelPackages: [],
      othersTitle: this.$gettext('Ostatní'),
      showDocuments: false,
      loadedWebdavInfo: false,
      idOperator: null,
      operatorLogo: null,
      operatorName: '',
    }
  },
  watch: {
    idOperator() {
      this.getProgramStructureAndThematicPackages()
    }
  },
  computed: {
    hasLogo() {
      return this.operatorLogo !== null && this.operatorLogo !== ''
    },
    pathToLogo() {
      return 'uploads/operator_logos/' + this.operatorLogo
    },
    changeOperatorAllowed(){
      return this.$_readActionAllowedAll && this.$_loggedUser_canChangeOperator;
    }
  },
  methods: {
    getDownloads() {
      this.setLoadingMessage()
      this.downloadService.getDownloads()
          .then(data => {
            this.showDocuments = true;
            this.activateTab('documents')
            this.emptyMessage()
            this.publicDirs = data['public_dirs']
            this.publicFiles = data['public_files']
          })
          .catch(function (error) {
            this.showDocuments = false;
            this.activateTab('program-structure');
            this.emptyMessage();
          }.bind(this))
    },
    getProgramStructureAndThematicPackages() {
      const params = {}
      if (this.$_readActionAllowedAllOrOwnAndGlobal) {
        params['id_operator'] = this.idOperator
      }

      this.operatorService.getProgramStructure(params)
          .then(data => {
            this.channels = data.channels
            this.basicChannelPackages = data.basic_packages
            this.thematicChannelPackages = data.thematic_packages
            this.operatorLogo = data.operator_logo
            this.operatorName = data.operator_name
          })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/Downloads.vue